<template>
  <div>
    <UserPageActions v-if="canEditNews">
      <Card class="w-100">
        <template #content>
          <div class="d-flex w-100 justify-content-end">
            <BasicButton
              label="編集"
              variant="secondary"
              outlined
              icon="pi pi-pencil"
              @click="goto({ name: 'UsersNewsEdit', params: { id: id } })"
            />
          </div>
        </template>
      </Card>
    </UserPageActions>

    <Card>
      <template #content>
        <NewsShow v-if="news" :news="news" is-user-page />
        <div class="d-flex flex-wrap justify-content-center my-5">
          <BasicButton
            label="戻る"
            variant="secondary"
            class="me-5"
            icon="pi pi-arrow-left"
            outlined
            @click="backto({ confirm: false })"
          />
          <BasicButton
            v-if="canEditNews"
            label="編集"
            variant="secondary"
            icon="pi pi-pencil"
            outlined
            @click="goto({ name: 'UsersNewsEdit', params: { id: id } })"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useNews, useRouterUtil, useUser } from "/@/vue/composables";
import { UserPageActions } from "/@/vue/components/Layouts";
import { Show as NewsShow } from "/@/vue/components/Molecules/News";
import { BasicButton } from "/@/vue/components/Atom";
import Card from "primevue/card";

const { getNewsItem } = useNews();
const { currentRouteParams, goto, backto } = useRouterUtil();

const id = computed(() => {
  return Number(currentRouteParams.value.id as string);
});

const { data: news } = getNewsItem(id, { admin: true });

// user

const { getUser, canEditNews } = useUser();
const { data: user } = getUser();
</script>

<style scoped></style>
